/**
 * Formato de importes contables: separador de miles y SIEMPRE dos decimales.
 *
 * El filtro global `convertPesoArg` usa el default de Intl (0 a 3 decimales),
 * así que $ 1 y $ 1.000,5 quedan con distinto ancho de coma y las columnas de
 * un asiento no se leen en vertical. En contabilidad los centavos siempre van.
 */
const FORMATO = new Intl.NumberFormat('es-AR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatearImporte(valor) {
  const numero = Number(valor);
  if (valor === null || valor === undefined || valor === '' || isNaN(numero)) {
    return '';
  }
  return FORMATO.format(numero);
}

/** "1.500", "10.419.090": puntos agrupando de a tres, sin decimales. */
const SOLO_MILES = /^-?\d{1,3}(\.\d{3})+$/;

/**
 * Lee un importe tipeado a mano y devuelve un Number.
 *
 * Acepta "10.419.090,32" (como lo escribe el contador) y "10419090.32" (como
 * venía saliendo del input numérico). El punto es separador de miles cuando hay
 * una coma decimal, o cuando agrupa de a tres dígitos exactos; en cualquier otro
 * caso sigue siendo el punto decimal de siempre, así "1.50" no se vuelve 150.
 */
export function parsearImporte(valor) {
  if (valor === null || valor === undefined) return 0;
  if (typeof valor === 'number') return isNaN(valor) ? 0 : valor;

  let texto = String(valor).trim().replace(/[$\s]/g, '');
  if (!texto) return 0;

  if (texto.includes(',')) {
    texto = texto.replace(/\./g, '').replace(',', '.');
  } else if (SOLO_MILES.test(texto)) {
    texto = texto.replace(/\./g, '');
  }

  const numero = Number(texto);
  return isNaN(numero) ? 0 : numero;
}

/** A dos decimales, que es lo que acepta el DecimalField del backend. */
export function redondearImporte(valor) {
  return Math.round(parsearImporte(valor) * 100) / 100;
}

/** Suma en centavos: en punto flotante 0.1 + 0.2 no da 0.3 y el asiento no cuadra. */
export function sumarImportes(valores) {
  const centavos = valores.reduce(
    (acc, valor) => acc + Math.round(parsearImporte(valor) * 100),
    0
  );
  return centavos / 100;
}
